import script from "./MainMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./MainMenu.vue?vue&type=script&setup=true&lang=js"

import "./MainMenu.vue?vue&type=style&index=0&id=79ad338f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79ad338f"]])

export default __exports__